// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"338":"31420fc2","447":"31420fc2","638":"31420fc2","664":"31420fc2","686":"31420fc2"}[chunkId] + ".chunk.css";
};